/** Placeholder every event-scoped href carries in the registry. */
export const EVENT_ID_TOKEN = "{eventId}";

/**
 * Substitutes the resolved event id into a registry href.
 *
 * Registry hrefs are written once with a `{eventId}` placeholder so a single
 * registry serves every event; resolution happens at selection time, when the
 * scope is actually known.
 *
 * @param href - The registry href, which may contain `{eventId}`.
 * @param eventId - The resolved event id, or null when scope is unknown.
 * @returns The resolved href, or null when the href needs an event id and none
 *   was supplied — the caller must ask rather than navigate somewhere wrong.
 */
export function resolveHref(href: string, eventId: string | null): string | null {
  if (!href.includes(EVENT_ID_TOKEN)) return href;
  if (!eventId) return null;
  return href.split(EVENT_ID_TOKEN).join(eventId);
}
